//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Glasgow",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      item1List: [
        { value: '1', name: '<50' },
        { value: '2', name: '≥50' },
      ],
      item2List: [
        { value: '1', name: '<15' },
        { value: '2', name: '≥15' },
      ],
      item3List: [
        { value: '1', name: '<5' },
        { value: '2', name: '≥5' },
      ],
      item4List: [
        { value: '1', name: '<1.5' },
        { value: '2', name: '≥1.5' },
        { value: '3', name: '>2.0' },
      ],
      item5List: [
        { value: '1', name: '<125' },
        { value: '2', name: '125-250' },
        { value: '3', name: '>250' },
      ],
      text: ''
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        if (result < 9) {
          self.text = '预后较好'
        } else {
          self.text = '预后差'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Glasgow.vue